import { render, staticRenderFns } from "./_base-tags-picker.vue?vue&type=template&id=4f5dbf2e&scoped=true&"
import script from "./_base-tags-picker.vue?vue&type=script&lang=js&"
export * from "./_base-tags-picker.vue?vue&type=script&lang=js&"
import style0 from "./_base-tags-picker.vue?vue&type=style&index=0&id=4f5dbf2e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5dbf2e",
  null
  
)

export default component.exports